import { Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { useCallback, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import type { ITableTooltip, TooltipPosition } from './Tooltip.helpers';

const TableTooltip = ({ children, message = 'Click to view details', enabled = true, truncate }: ITableTooltip) => {
	const [position, setPosition] = useState<TooltipPosition | null>(null);
	const wrapRef = useRef<HTMLDivElement>(null);

	const handleMouseEnter = useCallback(() => {
		if (!wrapRef.current) return;
		const rect = wrapRef.current.getBoundingClientRect();
		setPosition({
			top: rect.top - 8,
			left: rect.left + rect.width / 2,
		});
	}, []);

	const handleMouseLeave = useCallback(() => {
		setPosition(null);
	}, []);

	if (!enabled) return <>{children}</>;

	return (
		<>
			<Typography
				as='span'
				ref={wrapRef}
				className={classNameMerger('table-row-tooltip', truncate && 'truncate')}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				{children}
			</Typography>

			{position &&
				createPortal(
					<div
						className='table-row-tooltip__bubble'
						style={{
							top: position.top,
							left: position.left,
						}}
					>
						{message}
					</div>,
					document.body
				)}
		</>
	);
};

export default TableTooltip;
